import { render, staticRenderFns } from "./zen_why_a_charge.vue?vue&type=template&id=3a0b2a7a&scoped=true&"
import script from "./zen_why_a_charge.vue?vue&type=script&lang=js&"
export * from "./zen_why_a_charge.vue?vue&type=script&lang=js&"
import style0 from "./zen_why_a_charge.vue?vue&type=style&index=0&id=3a0b2a7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0b2a7a",
  null
  
)

export default component.exports